/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resetPassword.defs.js'
export * as $defs from './resetPassword.defs.js'
